exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pace {\r\n    -webkit-pointer-events: none;\r\n    pointer-events: none;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n        user-select: none;\r\n}\r\n\r\n.pace-inactive {\r\n    display: none;\r\n}\r\n\r\n.pace .pace-progress {\r\n    background: #f62459;\r\n    position: fixed;\r\n    z-index: 2000;\r\n    top: 0;\r\n    right: 100%;\r\n    width: 100%;\r\n    height: 2px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/INMOGR/Desktop/Angular Project/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/Users/INMOGR/Desktop/Angular Project/src/assets/vendor/pace/css/pace-minimal.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/assets/vendor/pace/css/pace-minimal.css
// module chunks = styles